import clsx from 'clsx';

import { paymentProviders } from '@/common/components/PaymentProviders/paymentProvidersData';
import { StaticImage } from '@/common/constants/displateRoutes';

import styles from './paymentProviders.module.scss';

interface PaymentProvidersProps {
  className?: string;
  countryCode?: string;
}

const PaymentProviders = ({ className, countryCode }: PaymentProvidersProps) => (
  <div className={clsx(styles.paymentImages, className)}>
    {paymentProviders(countryCode).map((image, index) => (
      <img
        alt={image.alt}
        draggable={false}
        key={index}
        loading="lazy"
        src={StaticImage(image.src)}
      />
    ))}
  </div>
);

export default PaymentProviders;
